/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, target: NonNullable<unknown> }} Ui_Charts_Sets_Of_TargetInputs */

const en_us2_ui_charts_sets_of_target = /** @type {(inputs: Ui_Charts_Sets_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} of ${i?.target}`)
};

const pt_br2_ui_charts_sets_of_target = /** @type {(inputs: Ui_Charts_Sets_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} de ${i?.target}`)
};

const es_419_ui_charts_sets_of_target = /** @type {(inputs: Ui_Charts_Sets_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} de ${i?.target}`)
};

const pt_pt2_ui_charts_sets_of_target = /** @type {(inputs: Ui_Charts_Sets_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} de ${i?.target}`)
};

const fr_fr2_ui_charts_sets_of_target = /** @type {(inputs: Ui_Charts_Sets_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} sur ${i?.target}`)
};

const de_de2_ui_charts_sets_of_target = /** @type {(inputs: Ui_Charts_Sets_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} von ${i?.target}`)
};

const it_it2_ui_charts_sets_of_target = /** @type {(inputs: Ui_Charts_Sets_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} di ${i?.target}`)
};

/**
* | output |
* | --- |
* | "{sets} of {target}" |
*
* @param {Ui_Charts_Sets_Of_TargetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_charts_sets_of_target = /** @type {((inputs: Ui_Charts_Sets_Of_TargetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Charts_Sets_Of_TargetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_charts_sets_of_target(inputs)
	if (locale === "es-419") return es_419_ui_charts_sets_of_target(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_charts_sets_of_target(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_charts_sets_of_target(inputs)
	if (locale === "de-DE") return de_de2_ui_charts_sets_of_target(inputs)
	if (locale === "it-IT") return it_it2_ui_charts_sets_of_target(inputs)
	return en_us2_ui_charts_sets_of_target(inputs)
});
export { ui_charts_sets_of_target as "ui-charts.sets_of_target" }